import { useQuery } from '@tanstack/react-query'
import { businessUnitsApi } from '@/services/businessUnits/businessUnits'

export const useGetBusinessUnits = () => {
  return useQuery({
    queryKey: ['businessUnits'],
    queryFn: businessUnitsApi.getBusinessUnits,
    staleTime: 1000 * 60 * 5, // 5 minutes - BU list doesn't change often
  })
}

export const useGetDepartments = () => {
  return useQuery({
    queryKey: ['departments'],
    queryFn: businessUnitsApi.getDepartments,
    staleTime: 1000 * 60 * 5, // 5 minutes - Department list doesn't change often
  })
}

export const useGetBUKeywords = (departmentName: string | undefined) => {
  return useQuery({
    queryKey: ['buKeywords', departmentName],
    queryFn: () => {
      if (!departmentName) throw new Error('Department name is required')
      return businessUnitsApi.getBUKeywords(departmentName)
    },
    enabled: !!departmentName && departmentName !== 'all', // Only run query if department is defined
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  })
}
